/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { UserInteractionProvider } from './contexts/UserInteractionContext';
import Navbar from './components/Navbar';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';

const Oferta = React.lazy(() => import('./pages/Oferta'));
const AboutUs = React.lazy(() => import('./pages/AboutUs'));
const Portfolio = React.lazy(() => import('./pages/Portfolio'));
const BlogPage = React.lazy(() => import('./pages/BlogPage'));
const UXDesignPage = React.lazy(() => import('./pages/UXDesignPage'));
const WebsiteArchitecturePage = React.lazy(() => import('./pages/WebsiteArchitecturePage'));
const GoogleMetaAdsPage = React.lazy(() => import('./pages/GoogleMetaAdsPage'));
const RebrandingPage = React.lazy(() => import('./pages/RebrandingPage'));
const Kontakt = React.lazy(() => import('./pages/Kontakt'));
const StartProject = React.lazy(() => import('./pages/StartProject'));
const WebSites = React.lazy(() => import('./pages/WebSites'));
const OnlineShops = React.lazy(() => import('./pages/OnlineShops'));
const SEO = React.lazy(() => import('./pages/SEO'));
const Ads = React.lazy(() => import('./pages/Ads'));
const ProjectDetails = React.lazy(() => import('./pages/ProjectDetails'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));

export default function App() {
  return (
    <LanguageProvider>
      <UserInteractionProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <CookieBanner />
          <Suspense fallback={<div className="min-h-screen bg-black flex items-center justify-center text-white font-syne text-xl">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/o-nas" element={<AboutUs />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/portfolio/:id" element={<ProjectDetails />} />
              <Route path="/oferta" element={<Oferta />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/ux-design" element={<UXDesignPage />} />
              <Route path="/blog/architektura-strony" element={<WebsiteArchitecturePage />} />
              <Route path="/blog/kampanie-reklamowe" element={<GoogleMetaAdsPage />} />
              <Route path="/blog/rebranding-strony" element={<RebrandingPage />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/zacznij-projekt" element={<StartProject />} />
              <Route path="/strony-internetowe" element={<WebSites />} />
              <Route path="/sklepy-internetowe" element={<OnlineShops />} />
              <Route path="/pozycjonowanie-stron" element={<SEO />} />
              <Route path="/kampanie-reklamowe" element={<Ads />} />
              <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </UserInteractionProvider>
    </LanguageProvider>
  );
}
